import request from '@/utils/request'
export function update(param) {
  return request({
    url: '/forgetPassword',
    method: 'post',
    data: param
  })
}
export function sends(param) {
  return request({
    url: '/sendNote',
    method: 'post',
    data: {
      thirdlyId:param
  }
  })
}



// WEBPACK FOOTER //
// ./src/api/forgotpassword.js